import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { ErrorBoundary } from '../../components/error-boundary';
import { AtsPlayer } from '../../components/Player/ats-player/ats-player';
import { AtsTrailerPlayer } from '../../components/Player/ats-player/ats-trailer-player';
import { routes } from '../../config';
import { useRootMenu } from '../../queries/ats/layout/queries';
import { Layout } from '../../queries/ats/layout/types';
import Cast from '../../views/cast';
import Pvr from '../../views/newpvr';
import { NotFound } from '../../views/not-found/not-found';
import GenreList from '../../views/programarchive/GenreList';
import Settings from '../../views/settings/Settings';
import TvChannelsLoader from '../../views/tv/TvWrapper';
import WatchTv from '../../views/tv/WatchTv';
import TvGuide from '../../views/tvguide';
import { NestedRoutes } from '../nested-routes';
import { UnmanagedRouteContextProvider } from './unmanaged-route-context';

function RoutesByAction({ item }: { item: Layout.SectionItemUnmanaged }) {
  const action = item.params.action;

  if (!action) {
    console.error('No action found for unmanaged menu item', item);
    return null;
  }

  switch (action) {
    case 'my-recordings':
      return <Pvr />;
    case 'tv-guide':
      return <TvGuide />;
    default:
      return null;
  }
}
export function UnmanagedRoutes() {
  const { unmanaged, playback, vod, settings, watchTv, tvguide, programarchive } = routes;

  const { data: unmanagedMenuItems = [] } = useRootMenu({
    select: (data) => {
      const items = data.filter((item): item is Layout.SectionItemUnmanaged => item.type === 'unmanaged');
      return items.filter((item) => item.params.action);
    },
  });

  return (
    <NestedRoutes>
      {unmanagedMenuItems.map((item) => (
        <Route key={item.params?.action} path={`/${item.slug}`}>
          <UnmanagedRouteContextProvider slug={item.slug}>
            <RoutesByAction item={item} />
          </UnmanagedRouteContextProvider>
        </Route>
      ))}

      <Route path={`${playback}/:platformTitleId`} exact>
        <ErrorBoundary>
          <AtsPlayer />
        </ErrorBoundary>
      </Route>

      <Route path={`${playback}${vod.playTrailer}/:platformTitleId/:providerIdentifier`} exact>
        <ErrorBoundary>
          <AtsTrailerPlayer />
        </ErrorBoundary>
      </Route>

      <Route path={'/se-tv/:programarkiv'} exact>
        <WatchTv />
      </Route>

      <Route path={'/tv/:channelId'}>
        <TvChannelsLoader />
      </Route>

      <Route path={settings.base} exact>
        <Settings />
      </Route>

      <Route path={programarchive.base + programarchive.channel + '/:channelId'}>
        <GenreList channelMode={true} />
      </Route>

      <Route path={'/cast/:castId'}>
        <Cast />
      </Route>

      <Route path={unmanaged.watchTv}>
        <Redirect to={watchTv.base + watchTv.live} />
      </Route>

      <Route path={tvguide.base}>
        <TvGuide />
      </Route>

      <Route path="/*">
        <NotFound />
      </Route>
    </NestedRoutes>
  );
}
